<template>
  <div class="country-dropdown" v-show="elementActive">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
        <select v-model="currentValue" class="form-select inner-select" :disabled="elementDisabled">
          <option :value="null" v-show="currentValueDefined">Please Select</option>
          <option :value="undefined" v-show="!currentValueDefined">Please Select</option>
          <option v-for="val in values" :value="val.value" :key="val.id">{{val.display}}</option>
        </select>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import fetchPortalJson from '@/js/PortalFetchJson'
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'CountryDropDown',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    return {
      countries: []
    }
  },
  methods: {
    async getCountries () {
      this.countries = (await fetchPortalJson('countries')).countries
    }
  },
  computed: {
    values () {
      return this.countries
    }
  },
  mounted () {
    if (this.countries.length) {
      this.getCountries()
    }
  },
  watch: {
  }
}
</script>
